import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { GeneralDataSharing, noData } from 'src/app/core/global-data-sharing/model/general-data-sharing';

@Injectable({
  providedIn: 'root'
})
export class GeneralDataSharingService {
  private dataSubject$ = new BehaviorSubject<GeneralDataSharing>({...noData});

  setData(data: GeneralDataSharing) {
    const prevData = {...this.dataSubject$.getValue(), ...data};

    this.dataSubject$.next(prevData);
  }

  getData() {
    return this.dataSubject$.asObservable();
  }

  deleteData(key?: string) {
    const data = {...this.dataSubject$.getValue()};

    if (!key) {
      this.dataSubject$.next({...noData});
      return;
    }
    delete data[key as keyof GeneralDataSharing];
    this.dataSubject$.next(data);
  }
}
